import { NOT_NUMBER_REGEXP, stringToNullableNumberFilter, textFilter } from '@sofology/sofologycomponents';

import { PropertyDescriptionTypes } from 'models';
import { toStringFilter, toNullableNumberFilter, toNullableString } from './formFilters';
import { DynamicControlFilterType } from './formHelperAdditionalData';
import { isNumberableSelectProperty, isNumberProperty } from './propertyTypeHelper';

const DATE_FORMAT = 'yyyy-MM-dd';

export function getNumberControlFilters(property: PropertyDescriptionTypes): DynamicControlFilterType[] {
    let filters: DynamicControlFilterType[] = [];
    if (isNumberableSelectProperty(property)) {
        return filters = [stringToNullableNumberFilter()];
    }

    if (isNumberProperty(property)) {
        filters = [toStringFilter(), textFilter(NOT_NUMBER_REGEXP), toNullableNumberFilter()];
    }

    return filters;
}

export function getDateControlFilters(): DynamicControlFilterType[] {
    let filters: DynamicControlFilterType[] = [toStringFilter(), toNullableString(DATE_FORMAT)];

    return filters;
}